import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'PALETTE',
    entityName: 'TRANSPORT_COLLI',
});

const initialState = {
    ...crudInitialState,
    deletedTransportColli: {},
    deleting: false,
    saving: false,
    external: false,
    gallery: false
};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }
    // Handle other actions
    switch (action.type) {
        case 'GALLERY_OPEN_TRANSPORT':
            return { ...state, gallery: !state.gallery };
        case 'CLEAR_STATE':
            return { ...state, loaded: null };
        case 'EXTERNAL_TRANSPORT':
            return { ...state, external: !state.external };
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
